import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

interface UsageChartProps {
  usage: number;
  limit: number;
}

const UsageChart: React.FC<UsageChartProps> = ({ usage, limit }) => {
  const data = [
    { name: '使用済み', value: usage },
    { name: '残り', value: Math.max(0, limit - usage) }
  ];
  
  return (
    <div className="relative w-48 h-48 md:w-64 md:h-64 mx-auto">
      <ResponsiveContainer>
        <PieChart>
          <Pie
            data={data}
            innerRadius="60%"
            outerRadius="100%"
            paddingAngle={2}
            dataKey="value"
            startAngle={90}
            endAngle={-270}
          >
            <Cell fill="#4F46E5" />
            <Cell fill="#E5E7EB" />
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center">
          <div className="text-3xl font-bold">{usage}</div>
          <div className="text-gray-500">/ {limit}</div>
        </div>
      </div>
    </div>
  );
};

export default UsageChart;
